module.exports = __webpack_public_path__ + "static/VS_icon03-01-2a94964e0f7839b8e37c087e12691297.png";